import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HeroSection() {
  const featured = comics.filter((c) => c.isHot).slice(0, 3);

  return (
    <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=artistic%20abstract%20manga%20comic%20collage%20with%20warm%20orange%20coral%20and%20cream%20tones%2C%20soft%20gradient%20overlay%2C%20decorative%20manga%20panel%20patterns%2C%20subtle%20line%20art%20elements%2C%20modern%20minimalist%20design%2C%20elegant%20composition%2C%20warm%20atmospheric%20background&width=1920&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="女神漫画首页背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-background-50" />
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="max-w-[1200px] w-full">
          <div className="text-center mb-10">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4 leading-tight">
              女神漫画
            </h1>
            <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto leading-relaxed">
              海量免费韩漫、日漫、国漫全集，热门排行榜推荐，下拉式在线阅读，每日更新最新章节
            </p>
            <div className="flex items-center justify-center gap-4 mt-8">
              <Link
                to="/category/hanman"
                className="px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                开始阅读
              </Link>
              <Link
                to="/about"
                className="px-6 py-3 border border-background-200/60 text-background-100 rounded-full text-sm font-medium hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4 md:gap-6 max-w-[900px] mx-auto">
            {featured.map((comic) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="group cursor-pointer"
              >
                <div className="relative overflow-hidden rounded-xl aspect-[3/4]">
                  <img
                    src={comic.cover}
                    alt={`${comic.title} - 女神漫画热门推荐`}
                    title={`${comic.title} - 女神漫画`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <h3 className="text-sm md:text-base font-bold text-background-50 mb-1 line-clamp-1">
                      {comic.title}
                    </h3>
                    <div className="flex items-center gap-2">
                      <span className="text-xs text-background-200">{comic.author}</span>
                      <span className="flex items-center gap-0.5 text-xs text-primary-400">
                        <i className="ri-star-fill text-[10px]"></i>
                        {comic.rating}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}